import styled from "styled-components";
import React, {useRef, useState} from "react";
import {useClickAway} from "react-use";
import {Label} from "components/common/misc";
import Row from "layouts/Row";
import {Column} from "layouts/index";
import {COLORS} from "utils/constants";
import {AnimatedList} from "react-animated-list";

type MenuPosition = "center" | "left" | "right"
type MenuItem = {
  key: string | number,
  label:any,
  icon?: any,
  onClick: (key: string | number)=> void,
  disabled?: boolean
}
interface MenuProps {
  trigger: any,
  menu: Array<MenuItem>,
  position?: MenuPosition,
  label?: any
}

const Container = styled.div`
  position: relative;
`

const List = styled.ul`
  position: fixed;
  width: 200px;
  min-height: fit-content;
  max-height: 400px;
  z-index: 10000;
  transform: translateX(-199px);
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0, rgba(27, 31, 35, 0.15) 0 0 0 1px;
  background-color: white;
  border-radius: 4px;
  
`

const ListItem = styled.li<any>`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding:10px;
  color: ${({disabled}: any) => disabled ? COLORS.colorGray500 : 'auto'};
  transition: all 100ms linear;
  &:hover{
    background: whitesmoke;
  }
`

const Menu = (props: MenuProps) => {

  const {trigger, menu} = props;

  const [showList, setShowList] = useState(false);
  const ref = useRef(null);
  useClickAway(ref, ()=>{
    setShowList(()=> false)
  })

  return(
      <Container ref={ref}>
        <div onClick={()=> setShowList((prevState)=> !prevState)}>{trigger}</div>

        {
          showList ?  <List>
            {
              props.label ? <Column >
                <Row style={{padding:'10px'}}><Label>{props.label}</Label></Row>
                <div className={"hr"}></div>
              </Column> : null
            }
            <AnimatedList animation={"grow"}>
              {
                menu?.map((item:MenuItem, index: number)=> (
                  <ListItem disabled={item?.disabled} onClick={() => {
                    item?.onClick?.(item.key)
                    setShowList(() => false)
                  }} className={"button_effect"} key={`menu_list_item_${index}`}>
                    {
                      item?.icon && (<div style={{
                          width: '30px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>{item?.icon}</div>
                      )
                    }
                    {item?.label}
                  </ListItem>
                ))
              }
            </AnimatedList>
          </List> : null
        }

      </Container>
  )
}

export default Menu
